import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Cobrança pelo método de pagamento',
    [BillingMode.InternalInvoicing]: 'Cobrança sobre as vendas',
    active: 'Ativa',
    on_trial: 'Em período de teste',
    launch_pending: 'Em espera até à data de lançamento',
    billing_disabled: 'Faturação desativada',
    on_grace_period: 'Em período de graça',
    past_due: 'Em atraso',
    cancelled: 'Cancelada',
  },
};
